<p>edit-layer-tool works!</p>
